<template>
  <div class="main-page f-2" ref="tableContainer">
    <v-table
      v-if="adaptHeight"
      is-horizontal-resize
      is-vertical-resize
      column-width-drag
      style="width:100%"
      :height="adaptHeight"
      class="table-style"
      :columns="columns"
      :table-data="tableData"
      row-click-color="#edf7ff"
    ></v-table>
  </div>
</template>

<script>
import { clone } from "lodash";
export default {
  name: "graph_table",
  props: {
    graph_config: {}
  },
  components: {},
  data() {
    return {
      adaptHeight: undefined,
      tableData: [],
      columns: [],
      beforeColumns: [
        {
          field: "title",
          title: "片名",
          width: 100,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          isFrozen: true
        },
        {
          field: "crowd",
          title: "人群",
          width: 120,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          formatter: this.tableFormatter
        },
        {
          field: "-4",
          title: "映前四周",
          width: 120,
          titleAlign: "center",
          columnAlign: "center",
          formatter: this.tableFormatter,
          isResize: true
        },
        {
          field: "-3",
          title: "映前三周",
          width: 120,
          titleAlign: "center",
          columnAlign: "center",
          formatter: this.tableFormatter,
          isResize: true
        },
        {
          field: "-2",
          title: "映前二周",
          width: 120,
          titleAlign: "center",
          columnAlign: "center",
          formatter: this.tableFormatter,
          isResize: true
        },
        {
          field: "-1",
          title: "映前一周",
          width: 120,
          titleAlign: "center",
          columnAlign: "center",
          formatter: this.tableFormatter,
          isResize: true
        },
        {
          field: "0",
          title: "上映当周",
          width: 120,
          titleAlign: "center",
          columnAlign: "center",
          formatter: this.tableFormatter,
          isResize: true
        }
      ],
      afterColumns: [
        {
          field: "title",
          title: "片名",
          width: 100,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          isFrozen: true
        },
        {
          field: "crowd",
          title: "人群",
          width: 120,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          formatter: this.tableFormatter
        },
        {
          field: "1",
          title: "映后一周",
          width: 120,
          titleAlign: "center",
          columnAlign: "center",
          formatter: this.tableFormatter,
          isResize: true
        }
      ]
    };
  },
  computed: {},
  methods: {
    tableFormatter(rowData, rowIndex, pagingIndex, field) {
      if (field === "crowd") {
        // let base = this.graph_config.tableConfig.base[rowIndex]
        //   ? this.graph_config.tableConfig.base[rowIndex]
        //   : "--";
        // let data = rowData[field] + `(${base || "--"})`;
        // return base !== "--" && base < 50
        //   ? "<span>" +
        //       rowData[field] +
        //       '(<span style="color:red;">' +
        //       base +
        //       "</span>)</span>"
        //   : data;
        return rowData[field];
      } else {
        let data =
          rowData[field] && rowData[field] !== "--"
            ? rowData[field] + "%"
            : "--";
        return data;
      }
    },
    generateTableColumns(before_after) {
      if (before_after === "before") {
        this.columns = clone(this.beforeColumns);
      } else {
        this.columns = clone(this.afterColumns);
      }
    },
    generateTableFormatData() {
      this.tableData = [];
      let len = this.graph_config.datasets.length;
      for (let i = 0; i < len; i++) {
        let before_after =
          this.graph_config.labels.length === 1 ? "after" : "before";
        let tempObj = {
          launch: this.graph_config.tableConfig.launch[i] || "--",
          title: this.graph_config.tableConfig.movie_title[i] || "--",
          crowd: this.graph_config.tableConfig.crowd[i] || "--"
        };
        if (before_after === "before") {
          this.generateTableColumns("before");
          tempObj = Object.assign(tempObj, {
            "-4":
              this.graph_config.datasets[i].data[0] !== null
                ? this.graph_config.datasets[i].data[0]
                : "--",
            "-3":
              this.graph_config.datasets[i].data[1] !== null
                ? this.graph_config.datasets[i].data[1]
                : "--",
            "-2":
              this.graph_config.datasets[i].data[2] !== null
                ? this.graph_config.datasets[i].data[2]
                : "--",
            "-1":
              this.graph_config.datasets[i].data[3] !== null
                ? this.graph_config.datasets[i].data[3]
                : "--",
            "0":
              this.graph_config.datasets[i].data[4] !== null
                ? this.graph_config.datasets[i].data[4]
                : "--",
            "1": "--"
          });
        } else {
          this.generateTableColumns("after");
          tempObj = Object.assign(tempObj, {
            "-4": "--",
            "-3": "--",
            "-2": "--",
            "-1": "--",
            "0": "--",
            "1":
              this.graph_config.datasets[i].data[0] !== null
                ? this.graph_config.datasets[i].data[0]
                : "--"
          });
        }
        this.tableData.push(tempObj);
      }
      this.$emit("loadingStatus", false);
    }
  },
  watch: {
    graph_config: {
      handler: function(to, from) {
        this.generateTableFormatData();
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.adaptHeight = this.$refs.tableContainer.offsetHeight - 10;
    this.generateTableFormatData();
  }
};
</script>

<style lang="scss" scoped>
.main-page {
  height: 100%;
  width: 100%;
  // overflow-x: scroll;
  // overflow-y: scroll;
}
.table-style {
  height: 100%;
}
</style>